import EMailContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/EMailContent";

export default class EmailItem {
    /**
     * @constructor
     * @param {EMailContent} content 
     * @param {boolean} isRead 
     */
    constructor(content, isRead = false) {
        this.content = content;
        this.isRead = isRead;
    }

    toObject() {
        return {
            content: this.content.convertToObject(),
            isRead: this.isRead,
        };
    }

    fromObject(obj, languagePack) {
        if (obj.content) {
            const content = new EMailContent(languagePack);
            content.setPropertiesFromObject(obj.content);
            
            this.content = content;
        }

        this.isRead = obj.isRead;

        return this;
    }
}